__turbopack_context__.v({
  "captchaError": "AuthenticationForm-module__bwKOPW__captchaError",
  "message": "AuthenticationForm-module__bwKOPW__message",
});
